import { startLogin } from "./startLogin";
import {
    forceLogout,
    startEmailVerification,
    startFpp,
    startFppRegistration,
    startRetryFppLogin,
    startTermsApproval,
    startUnauthorized,
    startWelcome,
} from "../fpp-app";
import { termsApproval } from "./termsApproval";

/** State of login process. */
export type LoginState =
    | "loggingIn"
    | "loginFailed"
    | "notRegistered"
    | "authorized"
    | "unauthorized"
    | "emailNotVerified"
    | "termsApproved"
    | "termsNotApproved"
    | "fromInvitation";

export function changeLoginState(newState: LoginState) {
    switch (newState) {
        case "loggingIn":
            return startLogin();
        case "authorized":
            return termsApproval();
        case "notRegistered":
            return startFppRegistration();
        case "unauthorized":
            return startUnauthorized();
        case "emailNotVerified":
            return startEmailVerification();
        case "termsNotApproved":
            return startTermsApproval();
        case "termsApproved":
            return startFpp();
        case "loginFailed":
            return startWelcome();
        case "fromInvitation":
            return forceLogout();
        default:
            return startRetryFppLogin();
    }
}

export function startLoginFlow() {
    const basePath = window.location.origin;
    const fullPath = window.location.href;
    const subPath = fullPath.replace(basePath, "");
    if (subPath.startsWith("/invitation")) {
        return changeLoginState("fromInvitation");
    }
    changeLoginState("loggingIn");
}
